// src/redux/sagas/subscriptionSaga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { request } from '../../api/request';
import ENDPOINTS from '../../api/endpoints';
import { shouldSkipApiCalls } from '../../utils/appConfig';
import {
  fetchSubscriptionRequest,
  fetchSubscriptionSuccess,
  fetchSubscriptionFailure,
} from '../slices/subscriptionSlice';
import { SubscriptionResponse } from '../../types/subscription';

function* fetchSubscriptionSaga(): Generator<any, void, AxiosResponse<SubscriptionResponse>> {
  // Skip API calls if in preview mode
  if (shouldSkipApiCalls()) {
    return;
  }

  try {
    const url = ENDPOINTS.SUBSCRIPTION_API_PATH;
    const base = import.meta.env.VITE_INTEGRATIONS_BASE_URL;

    const response: AxiosResponse<SubscriptionResponse> = yield call(request, {
      method: 'GET',
      url,
      base,
    });

    // Extract subscription data from response
    const subscriptionData = response?.data?.data;

    if (subscriptionData) {
      yield put(fetchSubscriptionSuccess(subscriptionData));
    } else {
      yield put(fetchSubscriptionFailure('No subscription data found'));
    }
  } catch (error: unknown) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to fetch subscription';
    yield put(fetchSubscriptionFailure(errorMessage));
  }
}

export function* watchSubscriptionSaga() {
  yield takeEvery(fetchSubscriptionRequest.type, fetchSubscriptionSaga);
}
